import api from "./apiClient";
import {
  setAuthSession,
  clearAuthSession,
  setCompanyContext,
  clearCompanyContext,
} from "./apiClient";

/* ===================================================== */
/* AUTH REQUESTS                                         */
/* ===================================================== */

/**
 * Register user
 */
export const register = async ({ name, email }) => {
  if (!name || !email) {
    throw new Error("Name and email are required");
  }

  const { data } = await api.post("/auth/register", {
    name,
    email,
  });

  return data;
};

/**
 * Send OTP
 */
export const sendOTP = async ({ email }) => {
  if (!email) {
    throw new Error("Email is required");
  }

  const { data } = await api.post("/auth/send-otp", {
    email,
  });

  return data;
};

/**
 * Verify OTP (LOGIN)
 */
export const verifyOTP = async ({ email, otp }) => {
  if (!email) throw new Error("Email is required");
  if (!otp) throw new Error("OTP is required");

  const { data } = await api.post("/auth/verify-otp", {
    email,
    otp,
  });

  if (!data?.token) {
    throw new Error("Authentication failed");
  }

  /* ---------------- Save Session ---------------- */
  setAuthSession(data.token);

  /* ---------------- Company Context (Optional) ---------------- */
if (data?.company?._id) {
  setCompanyContext(data.company._id);
}

  return data;
};

/**
 * Get logged-in user profile
 */
export const getProfile = async () => {
  const { data } = await api.get("/user/profile");
  return data;
};

/**
 * Logout
 */
export const logout = async () => {
  try {
    await api.post("/auth/logout");
  } catch (err) {
    console.warn("Logout request failed:", err.message);
  }

  /* ---------------- Clear Session ---------------- */
  clearAuthSession();
  clearCompanyContext();

  /* ---------------- Redirect ---------------- */
  window.location.href = "/login";
};